module.exports = __webpack_public_path__ + "static/media/icon_dof.806c3082.ico";